import { css } from 'styled-components';
import { CFBaseSearchbarTokens, CFBaseSearchbarUtils } from '..';
export const rootBackgroundColor = ({ focused }) => focused
    ? CFBaseSearchbarTokens.BACKGROUND.FOCUSED
    : CFBaseSearchbarTokens.BACKGROUND.DEFAULT;
export const rootHeight = ({ fieldSize = 'md' }) => CFBaseSearchbarTokens.ROOT_HEIGHT[fieldSize.toUpperCase()];
export const rootOutlineColor = ({ focused }) => focused
    ? CFBaseSearchbarTokens.BORDER_COLOR.FOCUSED
    : CFBaseSearchbarTokens.BORDER_COLOR.DEFAULT;
export const rootPadding = ({ fieldSize, focused, hasText, }) => {
    const { paddingLeft, paddingRight } = CFBaseSearchbarUtils.getAnimatedStyles({
        fieldSize,
        focused,
        hasText,
    });
    return css `
    padding: 0 ${paddingRight}px 0 ${paddingLeft}px;
  `;
};
